import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const {
    borderRadius3,
    borderWidth2,
    colorBgBase,
    colorBorderInput,
    colorBorderInputFocus,
    colorIcon,
    colorIconDisabled,
    colorBgActionSecondaryActive,
    space2,
    space4,
    space16,
    space20,
  } = theme();

  const imageWidth = space16;
  const itemMarginRight = space2;
  const itemPadding = space2;

  const styles = StyleSheet.create({
    arrowButton: {
      backgroundColor: colorBgActionSecondaryActive,
      borderColor: colorBorderInput,
      borderRadius: "100%",
      borderWidth: borderWidth2,
    },
    arrowContainer: {
      alignItems: "center",
      height: "100%",
      justifyContent: "center",
      position: "absolute",
      zIndex: 1,
    },
    arrowGradient: {
      alignItems: "center",
      height: "100%",
      justifyContent: "center",
      position: "absolute",
      width: "100%",
      zIndex: 0,
    },
    arrowIcon: {
      color: colorIcon,
    },
    contentContainer: {
      backgroundColor: colorBgBase,
      flexDirection: "row",
      justifyContent: "center",
      minWidth: "100%",
      paddingHorizontal: space4,
      paddingVertical: space4,
    },
    image: {
      height: imageWidth,
      width: imageWidth,
    },
    item: {
      borderColor: colorIconDisabled,
      borderRadius: borderRadius3,
      borderWidth: borderWidth2,
      marginRight: itemMarginRight,
      padding: itemPadding,
    },
    itemActive: {
      borderColor: colorBorderInputFocus,
    },
    itemDesktop: {
      backgroundColor: colorBgBase,
    },
    itemLast: {
      marginRight: 0,
    },
  });

  return {
    ...styles,
    itemWidth: imageWidth + itemPadding * 2 + itemMarginRight,
    imageCdnWidth: imageWidth * 3, // 3x to have a better quality image
    arrowContainerBackgroundColor: colorBgBase,
    arrowContainerInnerPadding: space20,
    arrowContainerOuterPadding: space4,
  };
};

export { style };
